import { Injectable, OnInit, inject } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ResponsiveService {
  private breakpointObserver = inject(BreakpointObserver);

  // Pre-defined breakpoint observables
  isHandset$: Observable<boolean> = this.breakpointObserver.observe([Breakpoints.Handset, Breakpoints.Tablet])
    .pipe(
      map(result => result.matches),
      shareReplay(1)
    );

  isTablet$: Observable<boolean> = this.breakpointObserver.observe([Breakpoints.Tablet])
    .pipe(
      map(result => result.matches),
      shareReplay(1)
    );

  isDesktop$: Observable<boolean> = this.breakpointObserver.observe([Breakpoints.Web])
    .pipe(
      map(result => result.matches),
      shareReplay(1)
    );

  // Custom breakpoints
  isSmallScreen$: Observable<boolean> = this.breakpointObserver.observe(['(max-width: 599px)'])
    .pipe(
      map(result => result.matches),
      shareReplay(1)
    );

  isMediumScreen$: Observable<boolean> = this.breakpointObserver.observe(['(min-width: 600px) and (max-width: 959px)'])
    .pipe(
      map(result => result.matches),
      shareReplay(1)
    );

  isLargeScreen$: Observable<boolean> = this.breakpointObserver.observe(['(min-width: 960px)'])
    .pipe(
      map(result => result.matches),
      shareReplay(1)
    );

  // Utility methods
  isMatching(query: string): Observable<boolean> {
    return this.breakpointObserver.observe([query])
      .pipe(
        map(result => result.matches)
      );
  }

  getCurrentScreenSize(): Observable<'mobile' | 'tablet' | 'desktop'> {
    return this.breakpointObserver.observe([
      Breakpoints.Handset,
      Breakpoints.Tablet,
      Breakpoints.Web
    ]).pipe(
      map(result => {
        const breakpoints = result.breakpoints;
        if (breakpoints[Breakpoints.Handset]) return 'mobile';
        if (breakpoints[Breakpoints.Tablet]) return 'tablet';
        if (breakpoints[Breakpoints.Web]) return 'desktop';
        return 'desktop'; // default
      }),
      shareReplay(1)
    );
  }
}